import $ from 'jquery';
import Bloodhound from 'corejs-typeahead';
var typeahead = require('corejs-typeahead');

// Search autocomplete
const companies = new Bloodhound({
  datumTokenizer: Bloodhound.tokenizers.whitespace,
  queryTokenizer: Bloodhound.tokenizers.whitespace,
  remote: {
    url: '/search/autocomplete?query=%QUERY',
    wildcard: '%QUERY',
    transform: function (response) {
      return response.companies;
    }
  }
});

const equipment = new Bloodhound({
  datumTokenizer: Bloodhound.tokenizers.whitespace,
  queryTokenizer: Bloodhound.tokenizers.whitespace,
  remote: {
    url: '/search/autocomplete?query=%QUERY',
    wildcard: '%QUERY',
    transform: function (response) {
      return response.equipment;
    }
  }
});

const materials = new Bloodhound({
  datumTokenizer: Bloodhound.tokenizers.whitespace,
  queryTokenizer: Bloodhound.tokenizers.whitespace,
  remote: {
    url: '/search/autocomplete?query=%QUERY',
    wildcard: '%QUERY',
    transform: function (response) {
      return response.materials;
    }
  }
});

const consumables = new Bloodhound({
  datumTokenizer: Bloodhound.tokenizers.whitespace,
  queryTokenizer: Bloodhound.tokenizers.whitespace,
  remote: {
    url: '/search/autocomplete?query=%QUERY',
    wildcard: '%QUERY',
    transform: function (response) {
      return response.consumables;
    }
  }
});

const services = new Bloodhound({
  datumTokenizer: Bloodhound.tokenizers.whitespace,
  queryTokenizer: Bloodhound.tokenizers.whitespace,
  remote: {
    url: '/search/autocomplete?query=%QUERY',
    wildcard: '%QUERY',
    transform: function (response) {
      return response.services;
    }
  }
});

// Site Searches
const $searchField = $('#main-search-query,#home-search-query,#query');

$searchField.typeahead({
  minLength: 3
},
{
  name: 'companies',
  display: 'display',
  source: companies,
  templates: {
    header: '<h3>Companies</h3>'
  }
},
{
  name: 'equipment',
  display: 'display',
  source: equipment,
  templates: {
    header: '<h3>Equipment</h3>'
  }
},
{
  name: 'materials',
  display: 'display',
  source: materials,
  templates: {
    header: '<h3>Materials</h3>'
  }
},
{
  name: 'consumables',
  display: 'display',
  source: consumables,
  templates: {
    header: '<h3>Consumables</h3>'
  }
},
{
  name: 'services',
  display: 'display',
  source: services,
  templates: {
    header: '<h3>Services</h3>'
  }
});

$searchField.bind('typeahead:select', function (obj, datum) {
  const origin = window.location.origin;

  $('input[type=submit]').attr('disabled', 'disabled')
                         .addClass('submit-loading');
  if (datum.filter_by) {
    switch(datum.filter_by) {
    case 'company':
      window.location.href = `${origin}/companies/${datum.company_id}`;
      break;
    case 'group':
      window.location.href = `${origin}/search?group[]=${encodeURIComponent(datum.group)}`;
      break;
    case 'category':
      window.location.href = `${origin}/search?group[]=${encodeURIComponent(datum.group)}&product_hierarchy[]=${encodeURIComponent(datum.display)}`;
      break;
    default:
      window.location.href = `${origin}/search?query=${encodeURIComponent(datum.display)}`;
    }
  }
});

const $adminSearchField = $('#admin-query');

$adminSearchField.typeahead({
  minLength: 3
},
{
  name: 'companies',
  display: 'display',
  source: companies,
  templates: {
    header: '<h3>Companies</h3>'
  }
});

$adminSearchField.bind('typeahead:select', function (obj, datum) {
  const origin = window.location.origin;
  window.location.href = `${origin}/admin/companies/${datum.company_id}`;
});



// WEBPACK FOOTER //
// ./lib/assets/js/search-typeahead.js